export default __webpack_public_path__ + "483213e24e614681d9aa9c5aecec9bee.mov";